import { ContextualCan } from '@eigtech/ui-shared-auth'
import { CheckboxField } from '@eigtech/ui-shared-forms'
import {
  Alert,
  AlertContent,
  AlertDescription,
  AlertIcon,
  AlertTitle,
} from '@eigtech/ui/components/alert'
import { Stack } from '@eigtech/ui/components/stack'
import { InfoIcon } from 'lucide-react'

export function PublishNoteField() {
  return (
    <ContextualCan I="publishToXa" a="note">
      <Component />
    </ContextualCan>
  )
}

function Component() {
  return (
    <Stack className="gap-4">
      <Alert variant="info">
        <AlertIcon>
          <InfoIcon />
        </AlertIcon>
        <AlertContent>
          <AlertTitle>Publishing to XA</AlertTitle>
          <AlertDescription>
            Selecting this option will publish this note to XA, where it will be visible on the
            claim in that system.
          </AlertDescription>
        </AlertContent>
      </Alert>

      <CheckboxField
        fontWeight="semibold"
        label="Would you like to publish this note to XA?"
        name="publishOnCreate"
      />
    </Stack>
  )
}
